import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunk to fetch payment history
export const fetchPaymentHistory = createAsyncThunk(
  "payment/fetchPaymentHistory",
  async (userId, thunkAPI) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/GetAllPayments`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const sortedPayments = (response.data.data || []).sort(
        (a, b) => new Date(b.paidAt) - new Date(a.paidAt)
      );

      return sortedPayments;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    history: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearPaymentHistory: (state) => {
      state.history = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearPaymentHistory } = paymentSlice.actions;
export default paymentSlice.reducer;
